export default "__VITE_ASSET__CUf2vh7j__"